export default __webpack_public_path__ + "static/media/dollar-dashboard.f9050a14.svg";